import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';

import { throwIfAlreadyLoaded } from './module-import-guard';
import { EventService } from './event.service';
import { TokenService } from './auth/auth-token.service';
import { AuthService } from './auth/auth.service';
import { AuthGuardService } from './auth/auth-guard.service';
import { ErrorService } from './error.service';
import { HeartbeatService } from './heartbeat.service';
import { FileHelperService } from './fileHelper.service';
import { CustomerService } from './services/customer.service';
import { ClientfileService } from './services/clientfile.service';
import { ProfileService } from './services/profile.service';
import { PlayerService } from './services/project-player.service';
import { ProjectService } from './services/project.service';
import { ProjectBranchService } from './services/projectBranch.service';
import { UserGroupService } from './services/user-group.service';
import { UserService } from './services/user.service';
import { PrimeNGModule } from './primeNG.module';
import { StatisticsService } from './services/statistics.service';
import { ReleaseBundleService } from './services/releasebundle.service';
import {CrashReportService} from './services/crashreport.service';
import {WebhookService} from './services';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        EventService, AuthService, TokenService, PrimeNGModule, ErrorService, HeartbeatService, AuthGuardService, FileHelperService,
        CustomerService, ProjectService, ProjectBranchService, ClientfileService, ProfileService, PlayerService,
        UserGroupService, UserService, StatisticsService, ReleaseBundleService, CrashReportService, WebhookService
    ],
    declarations: [

    ]
})
export class CoreModule {
    constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
        throwIfAlreadyLoaded(parentModule, 'CoreModule');
    }
}
